module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAVJJREFUSImllb1OwzAURs8XD0xEPACh5UlSdWDpwMyIKqSWiVdhaSWoeAtmVOYOvAGKsqBuZOtSM9CUhvzavaNjnyNf+3NEFN9A8IzsFqsH0rcXjqnzwRjpEdkt2LG4GGRCp/l3a7f3pMu5FzyKp1Iw27PgO/g/RwpmRPH0WHiOM4S9L0nXRYlGhL01WbI6Ag7WTgxZ8kHYW0saeUlq4LtWLwwAWbLykjTD5wBmP+oq6QAvClwkHeEAKu+7BcDupnWA1wtqJNZapPKSpuyYqkGg1C4feLPgQAKMfOAApSRXVTXcdlnasoPaw/5tV5cw1gta4Hm1SaoFzdf01SXxZUFbiBwTXxR0TaiD5E/gEH8XifGCO0gMUXwrBU/O8E6SfmI4u3wXOvGCt0iQhqUke//00+U8f20PyxD2P5GugA3WTkiXC2d4XlmyIuwnSENgA9z9AH4uEipldIvsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/remove.png
// module id = zK1T
// module chunks = 1